import { routerActions } from 'react-router-redux'
import { connectedReduxRedirect } from 'redux-auth-wrapper/history3/redirect'

export default () =>
  connectedReduxRedirect({
    wrapperDisplayName: 'UserIsNotAuthenticated',
    allowRedirectBack: false,
    redirectPath: '/',
    authenticatedSelector: ({ firebase }) => firebase.auth.isEmpty,
    authenticatingSelector: ({ firebase }) =>
      firebase.isInitializing || !firebase.auth.isLoaded,
    redirectAction: routerActions.replace,
  })



// WEBPACK FOOTER //
// ./src/behaviors/userIsNotAuthenticated.js